import type { FlexibleWeekChip } from "../types";

export interface CalendarFlexibleStripProps {
  items: FlexibleWeekChip[];
}

/**
 * §2.6 — the "This week" band. A flexible/target-frequency cadence has no
 * dated occurrences at all (a rolling-window count, not a projected
 * date), so it never places a chip inside a day cell — this read-only
 * summary strip is its ONLY calendar presence. Non-interactive spans, not
 * buttons: "completion never happens from the calendar" (Amendment 5
 * Decision 3's own explicit rule) — tapping one does nothing, so it isn't
 * a control. Text is the cadence's own server-rendered `phrase` verbatim,
 * never re-derived client-side.
 */
export function CalendarFlexibleStrip({ items }: CalendarFlexibleStripProps) {
  if (items.length === 0) return null;
  return (
    <div class="calendar-flexible-strip" role="group" aria-label="This week">
      {items.map((item) => (
        <span key={item.cadence_id} class="calendar-flexible-chip">
          {item.phrase}
        </span>
      ))}
    </div>
  );
}
